/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useNavigate } from "react-router-dom";
import ListDishes from "./ListDishes";

const Success = () => {
  const navigate = useNavigate();
  return (
    <section className="container-fluid">
      <ListDishes />
      <div className="overlay"></div>
      <div className="drawer small add-dish">
        <div className="alert-wrap">
          <img
            className="ico mb-4"
            src="/assets/images/alert-success-ico.svg"
            alt="success"
          />
          <h1 className="mb-4">Awesome!</h1>
          <p className="mid-gray mb-2">
            <small>Dish Details Saved – Nice Job, Chef!</small>
          </p>

          <button
            className="btn btn-primary rounded-5 px-5 mt-2 mb-2"
            onClick={() => navigate("/dish/add")}
          >
            Add New
          </button>
          <button
            className="btn btn-cancel rounded-5"
            onClick={() => navigate("/dish")}
          >
            Back to Home
          </button>
        </div>
      </div>
    </section>
  );
};
export default Success;
